import { MONEY_ACCOUNT_TYPE } from 'src/features/moneyAccounts/utils/types';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';
import { BadgeOption, CURRENCY } from 'src/types';
import { generalMessages } from 'src/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import EUR from 'src/assets/images/eur.svg';
import USD from 'src/assets/images/usd.svg';
import GBP from 'src/assets/images/gbp.svg';

export const MONEY_ACCOUNT_TYPE_TRANSLATION_MAP: Record<MONEY_ACCOUNT_TYPE, { id: string; defaultMessage: string }> = {
    [MONEY_ACCOUNT_TYPE.CASH]: moneyAccountsMessages.cash,
    [MONEY_ACCOUNT_TYPE.BANK]: moneyAccountsMessages.bank,
    [MONEY_ACCOUNT_TYPE.PROCESSOR]: moneyAccountsMessages.processor,
};

export const MONEY_ACCOUNT_TYPE_BADGE_MAP: Record<MONEY_ACCOUNT_TYPE, BadgeOption> = {
    [MONEY_ACCOUNT_TYPE.CASH]: {
        label: moneyAccountsMessages.cash,
        icon: ICON_MAP.CASH,
        theme: 'green',
    },
    [MONEY_ACCOUNT_TYPE.BANK]: {
        label: moneyAccountsMessages.bank,
        icon: ICON_MAP.BANK,
        theme: 'blue',
    },
    [MONEY_ACCOUNT_TYPE.PROCESSOR]: {
        label: moneyAccountsMessages.processor,
        icon: ICON_MAP.SUBSCRIPTION,
        theme: 'red',
    },
};

export const CURRENCY_MAP: Record<CURRENCY, { id: string; defaultMessage: string }> = {
    [CURRENCY.EUR]: moneyAccountsMessages.eur,
    [CURRENCY.GBP]: moneyAccountsMessages.gbp,
    [CURRENCY.USD]: moneyAccountsMessages.usd,
};

/** Currency as a filter-dropdown option. The cells render CellCurrencyBadge, which shows a flag. */
export const CURRENCY_BADGE_OPTIONS: Record<CURRENCY, BadgeOption> = {
    [CURRENCY.EUR]: {
        label: moneyAccountsMessages.eur,
        theme: 'blue',
    },
    [CURRENCY.GBP]: {
        label: moneyAccountsMessages.gbp,
        theme: 'indigo',
    },
    [CURRENCY.USD]: {
        label: moneyAccountsMessages.usd,
        theme: 'teal',
    },
};

export const CURRENCY_FLAG_MAP: Record<CURRENCY, string> = {
    [CURRENCY.EUR]: EUR,
    [CURRENCY.GBP]: GBP,
    [CURRENCY.USD]: USD,
};

export const BOOLEAN_MAP = {
    true: generalMessages.yes,
    false: generalMessages.no,
};

export const BOOLEAN_OPTIONS = ['true', 'false'];
